import styled from 'styled-components';
import { Button } from '@sketch/components';

const ButtonPill = styled(Button) `
  padding: 8px 10px;
`;
const AvatarWrapper = styled.div `
  margin-right: 8px;
`;
const WorkspaceName = styled.span `
  font-size: ${({ theme }) => theme.fontSizes.E};
  line-height: 1.4;
`;

export { AvatarWrapper, ButtonPill, WorkspaceName };
